import React from "react";
import { Margin } from "~/components/elements";
import * as S from "./styles";

export default function StepBubbles({ step, mobile }) {
  return (
    <Margin mt={mobile ? 5 : 8} mb={mobile ? 5 : 8}>
      <S.BubblesHolder>
        <S.Bubble active>
          1
          {!mobile && (
            <S.BubbleLable level="1" as="strong" active>
              CADASTRO
            </S.BubbleLable>
          )}
        </S.Bubble>
        <S.BubbleBar active={step >= 2} />

        <S.Bubble active={step >= 2}>
          2
          {!mobile && (
            <S.BubbleLable level="1" as="strong" active={step >= 2}>
              REGISTRO DA <br className="mobileOnly" /> COMPRA
            </S.BubbleLable>
          )}
        </S.Bubble>
        <S.BubbleBar active={step >= 3} />

        <S.Bubble active={step >= 3}>
          3
          {!mobile && (
            <S.BubbleLable level="1" as="strong" active={step >= 3}>
              CONFIRMAÇÃO
            </S.BubbleLable>
          )}
        </S.Bubble>
      </S.BubblesHolder>
    </Margin>
  );
}
